<template>
  <div class="edit-cnv-to-chapter-dailog dialog col-block">
    <div v-if="isEdit" class="option-container">
      <div class="delete-icon icon-block" :style="{ '--size': '40px' }" @click="e => deleteCNV()">
        <img :src="require('../../assets/images/case-detail-delete-icon.svg')" alt="" :style="{ height: '21px' }">
      </div>
    </div>
    <div class="block-container cnv col-block">
      <div class="title-container">
        <div class="title">{{ isEdit ? 'Edit the new CNV' : 'Create a new CNV'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="cnv-container col-block flex-start">
        <div class="form-container input-group row-block">
          <select class="form-input chr" v-model="cnv.CHROM" :style="cnv.CHROM ? {} : { color: '#A9A9A9' }">
            <option value="" disabled>{{ 'Chr'/* ___ */ }}</option>
            <option v-for="(option, index) in chromOptions" :key="index" :value="option.value">{{ option.title }}</option>
          </select>
          <div class="split">{{ ':' }}</div>
          <input type="text" class="form-input start" v-model="cnv.POS_START" :placeholder="'Start Position'/* ___ */">
          <div class="split">{{ '~' }}</div>
          <input type="text" class="form-input end" v-model="cnv.POS_END" :placeholder="'End Position'/* ___ */">
        </div>
      </div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="block-container gene col-block">
      <div class="title-container">
        <div class="title">{{ 'Enter relevant gene symbols'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="gene-container col-block flex-start">
        <div class="search-container row-block">
          <div class="search-input input-group" :style="{ flex: 1 }">
            <geneTag
              :style="{
                width: '100%'
              }"
              :disabled="!cnv.CHROM"
              :tagHeight="'300px'"
              :placeholder="'Gene name'/* ___ */"
              :init="query['gene']"
              :title="false"
              :dataInfo="tag['genes'].info"
              :genes="tag['genes'].datas ? tag['genes'].datas.filter(gene => (cnv.CHROM === 'chrM' && (gene.symbol || '').startsWith('MT-')) || (cnv.CHROM !== 'chrM' && !(gene.symbol || '').startsWith('MT-'))) : tag['genes'].datas"
              @input="content => { query['gene'] = content; }"
              @tag="content => { query['gene'] = content.name; curTag['gene'] = content; }"
              @send="content => (tag['genes'].datas || []).length && query['gene'] ? addToSearch(curTag['gene'] || query['gene']) : ''"
            ></geneTag>
            <img :src="require('../../assets/images/search-solid.svg')" alt="">
          </div>
          <div :style="{ width: '16px' }"></div>
          <button class="main-button circle-button" :class="{ loading: loading['addToSearch'] }" :disabled="!((tag['genes'].datas || []).length && query['gene'])" @click="e => (tag['genes'].datas || []).length && query['gene'] ? addToSearch(curTag['gene'] || query['gene']) : ''">
            <span>{{ 'Add'/* ___ */ }}</span>
          </button>
        </div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="gene-list-container row-block flex-start flex-wrap">
        <div class="gene-block row-block" v-for="(gene, index) in selectedGenes" :key="index" @click="e => selectedGenes.splice(index, 1)">
          <div class="gene-title">{{ gene.SYMBOL }}</div>
          <div :style="{ width: '5px' }"></div>
          <img class="gene-remove-icon" :src="require('../../assets/images/minus-tag-icon.svg')" alt="">
        </div>
      </div>
    </div>
    <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px', }">
    <div class="block-container chapter col-block">
      <div class="title-container">
        <div class="title">{{ 'Select at least one chapter'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '12px' }"></div>
      <div class="chapter-container row-block">
        <div class="chapter-list-container row-block flex-wrap">
          <div class="chapter-item-container" v-for="(chapter, index) in chapters" :key="index">
            <div class="chapter-item row-block" @click="e => selectedChapters = (selectedChapters.includes(chapter.value) ? selectedChapters.filter(c => c !== chapter.value) : selectedChapters.concat([chapter.value]))">
              <img :src="selectedChapters.includes(chapter.value) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')">
              <div :style="{ width: '8px' }"></div>
              <div class="chapter-title">{{ chapter.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => $emit('changeModal', {}, sendData)">
        <span>{{ isEdit ? 'Update'/* ___ */ : 'Create'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getCnvGenes } from '../../api'
import geneTag from '../tool/geneTag.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import { groupBy } from '../../constants/global/util'
import { chromMap } from '../../constants/global/data'

export default {
  components: {
    geneTag
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      cnv: {
        CHROM: '',
        genes: [],
        chapters: []
      },
      selectedGenes: [],
      selectedChapters: [],
      // search
      map: {
        gene: {}
      },
      query: {
        gene: ''
      },
      tag: {
        genes: {}
      },
      curTag: {
        gene: null
      },
      searchTimer: {
        gene: []
      },
      loading: {
        addToSearch: false
      }
    }
  },
  computed: {
    sendData () {
      let cnv = {
        CHROM: this.cnv.CHROM,
        POS_START: this.cnv.POS_START,
        POS_END: this.cnv.POS_END
      }
      let nGeneIDs = this.selectedGenes.map(gene => gene.gene_id)
      let oGeneIDs = this.cnv.genes.map(gene => gene.gene_id)
      let iGeneIDs = nGeneIDs.filter(id => oGeneIDs.includes(id))
      let genes = {
        add: this.selectedGenes.filter(gene => !iGeneIDs.includes(gene.gene_id)),
        original: this.selectedGenes.filter(gene => iGeneIDs.includes(gene.gene_id)),
        remove: this.cnv.genes.filter(gene => !iGeneIDs.includes(gene.gene_id))
      }
      let nChapterValues = this.selectedChapters
      let oChapterValues = this.cnv.chapters
      let iChapterValues = nChapterValues.filter(value => oChapterValues.includes(value))
      let chapters = {
        add: this.selectedChapters.filter(chapter => !iChapterValues.includes(chapter)),
        original: this.selectedChapters.filter(chapter => iChapterValues.includes(chapter)),
        remove: this.cnv.chapters.filter(chapter => !iChapterValues.includes(chapter))
      }
      if (Object.values(cnv).every(x => x) && this.selectedChapters.length) {
        return { cnv, genes, chapters }
      } else {
        return null
      }
    },
    chromOptions () {
      return Object.entries(chromMap).map(([key, value]) => ({ title: value.title, value: key }))
    },
    // param
    isEdit () {
      return this.param.defaultData
    },
    chapters () {
      return this.param.chapters
    }
  },
  watch: {
    'query.gene' (nv) {
      this.getGenes(nv)
    },
    'cnv.CHROM' (nv) {
      if (nv) {
        if (nv === 'chrM') {
          this.selectedGenes = this.selectedGenes.filter(gene => gene.SYMBOL.startsWith('MT-'))
        } else {
          this.selectedGenes = this.selectedGenes.filter(gene => !gene.SYMBOL.startsWith('MT-'))
        }
      }
    }
  },
  created () {
    if (this.param.defaultData) {
      this.cnv = { ...this.param.defaultData }
      this.selectedGenes = [...this.param.defaultData.genes]
      this.selectedChapters = [...this.param.defaultData.chapters]
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModal2Action'
    ]),
    async getGenes (query) {
      if ((this.curTag['gene'] || {}).name !== query) {
        this.tag['genes'] = {}
        if (this.searchTimer['gene']) {
          clearTimeout(this.searchTimer['gene'])
        }
        this.searchTimer['gene'] = setTimeout(async () => {
          if (!this.map['gene'][query] && query) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let response = null
              response = await getCnvGenes(query, false, config)
              let genes = response.data.data
              genes = groupBy(genes, gene => gene.gene_id).map(group => group[0])
              response = await getCnvGenes(query, true, config)
              let mtGenes = response.data.data
              mtGenes = groupBy(mtGenes, gene => gene.gene_id).map(group => group[0])
              this.map['gene'] = {
                ...this.map['gene'],
                [query]: {
                  info: null,
                  datas: [
                    ...genes.map(data => ({ ...data, name: data.symbol, type: 'gene' })),
                    ...mtGenes.map(data => ({ ...data, name: data.symbol, type: 'gene' }))
                  ]
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
            this.setLoadingAction(false)
          }
          this.tag['genes'] = this.map['gene'][query] || {}
        }, 500)
      }
    },
    async addToSearch (data) {
      data = data.type ? data : (this.map['gene'][this.query['gene']] || { datas: [] }).datas[0]
      if (data && !this.loading['addToSearch']) {
        this.loading['addToSearch'] = true
        switch (data.type) {
          case 'gene': {
            let oldData = this.selectedGenes.find(g => g.SYMBOL === data.symbol)
            if (!oldData) {
              this.selectedGenes.push({
                SYMBOL: data.symbol,
                gene_id: data.gene_id
              })
            }
            break
          }
          default: {}
        }
        this.query['gene'] = ''
        this.loading['addToSearch'] = false
      }
    },
    deleteCNV () {
      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'alert',
          content: '<span style="color:#FA3D3D">If you delete this variant, all the content inside will also be deleted. Do you want to delete the variant?</span>'/* ___ */,
          buttons: [
            {
              title: 'Cancel'/* ___ */,
              type: 'gray',
              result: false
            },
            {
              title: 'Delete'/* ___ */,
              type: 'alert',
              result: true
            }
          ]
        },
        callback: async result => {
          if (result) {
            this.$emit('changeModal', {}, {
              ...this.sendData,
              chapters: {
                add: [],
                original: [],
                remove: [...this.sendData.chapters.original, ...this.sendData.chapters.remove]
              }
            })
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editCNVToChapter.vue